export default class Result {
    successful: boolean;
    message: string;

    constructor(successful: boolean, message = "") {
        this.successful = successful;
        this.message = message;
    }
};
